module.exports = "/_next/static/images/790ca342a1b23d0c5a8beeaad045c1d7-analysis.svg.webp";